import { AppState } from '../AppTypes';
import { _hasFlags } from './hasFlags';

export const _hasFlag = (state: AppState) => {
  return (flag: string) => {
    return _hasFlags(state)([flag]);
  };
};
